import { PreventBrowseOutDialog } from "./preventBrowseOutDialog";
import { Router } from "./router";

export class PreventBrowseOut {
    private static sourcePath: string;
    private targetPath: string;
    message: any;
    constructor() {
        window.addEventListener("beforeunload", (e) => {
            if (this.message != null) {
                (e || window.event).returnValue = this.message; // Gecko + IE
                return this.message; // Gecko + Webkit, Safari, Chrome etc.
            }
        });
        window.addEventListener("unload", (e) => {
            this.firePageChangeEvent();
        });
        window.addEventListener("hashchange", (e: HashChangeEvent) => {
            if (this.message != null) {
                if (PreventBrowseOut.sourcePath !== e.newURL) {
                    this.targetPath = e.newURL;
                    window.location.href = e.oldURL;
                    PreventBrowseOut.sourcePath = e.oldURL;
                    new PreventBrowseOutDialog().confirmRoute(this.acceptCallbackRoute, this.message);
                } else {
                    Router.getInstance().resume();
                }
            } else {
                this.firePageChangeEvent();
                PreventBrowseOut.sourcePath = e.newURL;
                Router.getInstance().resume();
            }
        });

        window.addEventListener("popstate", (e: PopStateEvent) => {
            if (this.message != null) {
                Router.getInstance().pause();
            }
        });

        document.addEventListener("preventBrowseOut", (e: CustomEvent) => {
            this.message = e.detail.message;
        });

        document.addEventListener("allowBrowseOut", (e: CustomEvent) => {
            this.message = null;
        });
    }

    private acceptCallbackRoute = () => {
        // Do nothing
    }

    private firePageChangeEvent() {
        document.dispatchEvent(new CustomEvent("embededPageToClose"));
    }
}
